import {
    FETCH_WELLNESS_DAILY_STRESS_DATA,
    FETCH_WELLNESS_DAILY_STRESS_DATA_SUCCESS,
    FETCH_WELLNESS_DAILY_STRESS_DATA_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyStress: {},
    dailyStressFetching: false,
    dailyStressFetchFail: false
};

const fetchDailyStressRequested = (state, action) => {
    return {
        dailyStress: {
            ...state.dailyStress,
            [action.displayName]: {
                ...state.dailyStress[action.displayName],
                [action.calendarDate]: {}
            }
        },
        dailyStressFetching: true,
        dailyStressFetchFail: false
    };
};

const fetchDailyStressDataSuccess = (state, action) => {
    return {
        dailyStress: {
            ...state.dailyStress,
            [action.displayName]: {
                ...state.dailyStress[action.displayName],
                [action.calendarDate]: action.dailyStressData
            }
        },
        dailyStressFetching: false,
        dailyStressFetchFail: false
    };
};

const fetchDailyStressDataFail = (state, action) => {
    return {
        dailyStress: {
            ...state.dailyStress,
            [action.displayName]: {
                ...state.dailyStress[action.displayName],
                [action.calendarDate]: {}
            }
        },
        dailyStressFetching: false,
        dailyStressFetchFail: true
    };
};

const handlers = {
    [FETCH_WELLNESS_DAILY_STRESS_DATA]: fetchDailyStressRequested,
    [FETCH_WELLNESS_DAILY_STRESS_DATA_SUCCESS]: fetchDailyStressDataSuccess,
    [FETCH_WELLNESS_DAILY_STRESS_DATA_FAIL]: fetchDailyStressDataFail
};

// ======= Actions =======
export function fetchDailyStressData(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_WELLNESS_DAILY_STRESS_DATA,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getDailyStressData = (state, displayName, calendarDate) => {
    return state.dailyStressData.dailyStress[displayName]
        ? state.dailyStressData.dailyStress[displayName][calendarDate]
        : null;
};

export const isDailyStressFetching = (state) => {
    return state.dailyStressData.dailyStressFetching;
};

export const didDailyStressFetchFail = (state) => {
    return state.dailyStressData.dailyStressFetchFail;
};

// ======= Default =======
export default function dailyStressData(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
